// @flow

import * as React from 'react';
import './ModalWithOverlay.scss';

type ModalProps = {
  clickHandler: * => void,
  isModalOn: boolean,
  showCloseButton?: boolean,
  id?: string,
  extraClass: string,
  children: React.Node,
  closeBox: string,
  modalLabel?: string,
};

type CloseButtonProps = {
  clickHandler: * => void,
  isButtonInTabDisabled: boolean,
  str: string,
};

export const CloseButton = ({ clickHandler, isButtonInTabDisabled = false, str }: CloseButtonProps): React.Element<'button'> => (
  <button
    className="close-x"
    tabIndex="0"
    onClick={clickHandler}
    disabled={isButtonInTabDisabled}
    type="button"
  >
    {str}
  </button>
);

const stopBubbling = (e: SyntheticEvent<HTMLDivElement>) => { e.stopPropagation(); };

const ModalWithOverlay = (
  { id = null, clickHandler, isModalOn, children, showCloseButton, closeBox, extraClass = '', modalLabel = null }: ModalProps
): React.Element<'div'> => (
  <div
    id={id}
    className={`overlay ${isModalOn ? '' : 'hidden'}`}
    onClick={(e: SyntheticEvent<HTMLDivElement>) => { e.preventDefault(); clickHandler(); }}
  >
    <div
      className={`modal ${extraClass}`}
      onClick={stopBubbling}
      role="dialog"
      aria-label={modalLabel}
      aria-labelledby={id ? `${id}-modal-title` : null}
    >
      { children }

      {showCloseButton && (
        <CloseButton
          clickHandler={clickHandler}
          str={closeBox}
        />
      )}
    </div>
  </div>
);

ModalWithOverlay.defaultProps = {
  id: undefined,
  showCloseButton: true,
};

export default ModalWithOverlay;
